import { Component, OnInit } from "@angular/core";
import { AuthService } from "../_services/auth/auth.service";

import { Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Store } from "@ngrx/store";
import { User } from "../_models/user-models/user";
import { AlertifyService } from "../_services/common/alertify.service";
import { AppSessionState } from "../_services/common/app.service";
import { login } from "../_store/actions/login.actions";
import { UserSessionStateModel } from "../_store/models/user-session-state.model";
//loginModel
import { environment } from "../../environments/environment";
import { DataService } from "../_services";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  client: User;
  dark: boolean;
  checked: boolean;
  loginModel: any = {};
  showSpinner: boolean;
  isCloud: boolean = true;
  isDisabled: boolean = false;
  isLoaderVisible: boolean = false;

  constructor(
    private router: Router,
    private store: Store<any>,
    private authService: AuthService,
    private _dataService: DataService,
    private alertify: AlertifyService,
    private appSessionState: AppSessionState,
    private jwtHelperService: JwtHelperService
  ) {}

  ngOnInit() {
    localStorage.clear();

    this.isCloud = environment.isCloud;
    environment.isSiteAdmin = false;

    if (this.jwtHelperService.isTokenExpired(localStorage.getItem("token"))) {
      localStorage.clear();
      this.router.navigate(["/login"]);
    } else {
      this.routeToStudyWorklist();
    }
  }

  login() {
    this.isLoaderVisible = true;
    this.loginModel.IsCloud = this.isCloud;
    this._dataService.sharedLoginReqData = this.loginModel;
    this.authService.login(this.loginModel).subscribe(
      (data) => {
        if (data) {
          if (data.user.IsSuperAdmin) {
            environment.isSuperAdmin = true;
          }

          if (data.user.JobType == "A") {
            environment.isSiteAdmin = true;
          }

          this.appSessionState.setToken(
            data.tokenString,
            <User>data.userRights,
            "" + new Date()
          );

          this.appSessionState.setUserToSessionStorage(data.user);
          localStorage.setItem("immediateReport", "true");
          this.setUserSessionState(data);
          this.isLoaderVisible = false;

          this.client = JSON.parse(localStorage.getItem("user"));
          if (this.client.Is2faenable) {
            this.routeToTwoFAVerify();
          } else {
            this.routeToStudyWorklist();
            this.alertify.success("Logged in successfully.");
          }
        }
      },
      (error) => {
        this.isLoaderVisible = false;
        this.alertify.error("Failed to login");
      }
    );
  }

  setUserSessionState(data) {
    let loginModel: UserSessionStateModel = {
      LoginTime: new Date(),
      UserInfo: data.user,
    };
    this.store.dispatch(login({ userSessionDetail: loginModel }));
  }

  routeToStudyWorklist() {
    this.router.navigate(["/study/worklist"]);
  }

  private routeToTwoFAVerify() {
    this.router.navigate(["/two-factor-auth-verify"]);
  }

  showLoadingSpinner() {
    this.showSpinner = true;
    this.isDisabled = true;
  }

  hideLoadingSpinner() {
    this.showSpinner = false;
    this.isDisabled = false;
  }

  goToLink() {
    window.open("https://" + environment.OAuthUrl, "_self");
  }

  gotoForgetPassword() {
    this.router.navigate(["/reset-password/radiologist"]);
  }
}
